import { useRef } from 'react';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { AvatarButton } from '../../TopBar.styles';
import ProfileMenuPanel from './components/ProfileMenuPanel';
import ProfileMenuMobileOverlay from './components/ProfileMenuMobileOverlay';
import { useIsMobileViewport } from './hooks/useIsMobileViewport';
import { useProfileNameEditor } from './hooks/useProfileNameEditor';
import { useProfileMenuInteractions } from './hooks/useProfileMenuInteractions';
import { Menu, Wrap } from './ProfileMenu.styles';

const ProfileMenu = ({
	open,
	onToggle,
	onClose,
	userInitial,
	userData,
	tokenCount,
	onLogout,
	isLoggingOut = false,
	onNameUpdated,
}) => {
	const t = useLanguageData('profileAccount');
	const profileModal = useLanguageData('profileModal');
	const isMobile = useIsMobileViewport();
	const wrapRef = useRef(null);

	const {
		displayName,
		isSavingName,
		nameError,
		handleNameChange,
		handleNameBlur,
		handleNameKeyDown,
	} = useProfileNameEditor({
		userName: userData?.name,
		open,
		onNameUpdated,
		translations: t,
	});

	useProfileMenuInteractions({
		open,
		isMobile,
		onClose,
		wrapRef,
	});

	const panelProps = {
		userInitial,
		displayName,
		email: userData?.email,
		isSavingName,
		nameError,
		onNameChange: handleNameChange,
		onNameBlur: handleNameBlur,
		onNameKeyDown: handleNameKeyDown,
		tokenCount,
		planExpiry: userData?.planExpiry,
		onLogout,
		isLoggingOut,
		translations: t,
	};

	return (
		<Wrap ref={wrapRef}>
			<AvatarButton
				type="button"
				aria-label={t.account}
				aria-expanded={open}
				onClick={onToggle}
			>
				{userInitial}
			</AvatarButton>
			<Menu $open={open && !isMobile} role="menu" aria-hidden={!open || isMobile}>
				<ProfileMenuPanel {...panelProps} />
			</Menu>
			<ProfileMenuMobileOverlay
				open={open && isMobile}
				onClose={onClose}
				closeLabel={profileModal.close}
				accountLabel={t.account}
				panelProps={panelProps}
			/>
		</Wrap>
	);
};

export default ProfileMenu;
